import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

export const CameraVideoShape = ({
  width = 36,
  height = 36,
  fillColor = 'none',
  style
}: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 25"
    fill={fillColor}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.6336 7.47461C23.5744 7.44026 23.5072 7.42207 23.4388 7.42185C23.3704 7.42163 23.3031 7.4394 23.2437 7.47337L18.3594 10.2644V8.98438C18.3583 8.0523 17.9876 7.15869 17.3285 6.49961C16.6694 5.84053 15.7758 5.4698 14.8438 5.46875H2.34375C2.03305 5.46909 1.73518 5.59266 1.51548 5.81236C1.29579 6.03205 1.17221 6.32993 1.17188 6.64062V16.0156C1.17292 16.9477 1.54366 17.8413 2.20274 18.5004C2.86182 19.1595 3.75542 19.5302 4.6875 19.5312H17.1875C17.4982 19.5309 17.7961 19.4073 18.0158 19.1876C18.2355 18.9679 18.359 18.6701 18.3594 18.3594V14.7356L23.2437 17.5266C23.3031 17.5606 23.3704 17.5784 23.4388 17.5781C23.5072 17.5779 23.5744 17.5597 23.6336 17.5254C23.6928 17.491 23.7419 17.4417 23.776 17.3824C23.8102 17.3232 23.8281 17.2559 23.8281 17.1875V7.8125C23.8281 7.74407 23.8102 7.67685 23.776 7.61755C23.7419 7.55825 23.6928 7.50896 23.6336 7.47461ZM17.5781 18.3594C17.578 18.4629 17.5368 18.5622 17.4636 18.6355C17.3904 18.7087 17.2911 18.7499 17.1875 18.75H4.6875C3.96255 18.7492 3.26752 18.4608 2.7549 17.9482C2.24228 17.4356 1.95394 16.7406 1.95312 16.0156V6.64062C1.95323 6.53706 1.99442 6.43776 2.06765 6.36453C2.14088 6.29129 2.24018 6.2501 2.34375 6.25H14.8438C15.5687 6.25081 16.2637 6.53916 16.7763 7.05178C17.289 7.5644 17.5773 8.25942 17.5781 8.98438V18.3594ZM23.0469 16.5144L18.3594 13.8359V11.1641L23.0469 8.4856V16.5144Z"
      fill="black"
    />
  </svg>
);

export const CameraVideoFilledShape = ({
  width = 20,
  height = 20,
  fillColor = 'white',
  style
}: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill={fillColor}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.75 7.1875V14.6875C13.7496 15.0189 13.6178 15.3366 13.3835 15.571C13.1491 15.8053 12.8314 15.9371 12.5 15.9375H3.75C2.92149 15.9366 2.12718 15.607 1.54134 15.0212C0.955492 14.4353 0.625948 13.641 0.625 12.8125V5.3125C0.625379 4.9811 0.757197 4.66337 0.991535 4.42904C1.22587 4.1947 1.5436 4.06288 1.875 4.0625H10.625C11.4535 4.06345 12.2478 4.39299 12.8337 4.97884C13.4195 5.56468 13.7491 6.35899 13.75 7.1875ZM19.0637 5.70946C18.969 5.65453 18.8616 5.62542 18.7521 5.62505C18.6427 5.62467 18.535 5.65304 18.4399 5.70732L15.3149 7.49306C15.2193 7.54772 15.1397 7.62671 15.0844 7.72201C15.0291 7.81731 15 7.92555 15 8.03574V11.9643C15 12.0745 15.0291 12.1827 15.0844 12.278C15.1397 12.3733 15.2193 12.4523 15.3149 12.5069L18.4399 14.2927C18.535 14.347 18.6426 14.3754 18.7521 14.375C18.8616 14.3746 18.969 14.3455 19.0637 14.2905C19.1584 14.2356 19.237 14.1567 19.2916 14.0619C19.3462 13.967 19.375 13.8595 19.375 13.75V6.25C19.375 6.14053 19.3463 6.03297 19.2916 5.93811C19.237 5.84324 19.1584 5.76439 19.0637 5.70946Z"
      fill={fillColor}
    />
  </svg>
);
